import { useState } from 'react';

var useLoading = function useLoading() {
  var _useState = useState(false),
      isLoading = _useState[0],
      setState = _useState[1];

  var load = function load(aPromise) {
    setState(true);
    return aPromise.then(function (args) {
      setState(false);
      return Promise.resolve(args);
    }).catch(function (args) {
      setState(false);
      return Promise.reject(args);
    });
  };

  return [isLoading, load];
};

export default useLoading;